import React from 'react'
import { Subscriber } from 'react-broadcast'

const Product = ({ render }) => (
  <Subscriber channel="product">{render}</Subscriber>
)

export default Product



// WEBPACK FOOTER //
// ./src/components/Product/index.js